import { baseApi } from "../baseApi";

export const amenitiesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // CREATE AMENITY
    createAmenity: builder.mutation({
      query: (formData) => ({
        url: "/amenities-create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Amenities"],
    }),

    // GET ALL
    getAmenities: builder.query({
      query: ({ page = 1,limit = 10,search = "",status = "",}={}) =>
         `/amenities-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["Amenities"],
    }),

    getAmenityById: builder.query({
      query: (id) => `/amenities/${id}`,
    }),

    // UPDATE
   
    updateAmenity: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/amenities-edit/${id}`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Amenities"],
    }),
    // DELETE
    deleteAmenity: builder.mutation({
      query: (id) => ({
        url: `/amenities-delete/${id}`,
        method: "GET",
      }),
      invalidatesTags: ["Amenities"],
    }),
   AmenityChangeStatus: builder.mutation({
      query: (data) => ({
        url: `/amenities-status`,
        method: "DELETE",
        body:data
      }),
      invalidatesTags: ["Amenities"],
    }),

  }),
});

export const {
  useCreateAmenityMutation,
  useGetAmenitiesQuery,
  useGetAmenityByIdQuery,
  useUpdateAmenityMutation,
  useDeleteAmenityMutation,
  useAmenityChangeStatusMutation,
} = amenitiesApi;